import * as React from "react";
import * as ReactDOM from "react-dom";
import MapComponentReact from "./MapComponentReact";
import { ReactComponent } from "lexisnexis-form";
import settingsForm from "./MapComponent.settingsForm";

export default class MapComponent extends ReactComponent {
  private component: any;
  private dataValue: any;
  private updateValue: any;
  private id: string;
  private on: Function;
  private root: any;

  static schema(...extend) {
    const schema = ReactComponent.schema(
      {
        type: "mapComponent",
        key: "mapComponent",
        label: "Esri Mapping"
      },
      ...extend
    );
    schema.values = [];
    return schema;
  }

  static get builderInfo() {
    return {
      title: "Esri Mapping",
      group: "advanced",
      icon: "map-pin",
      weight: -10,
      schema: MapComponent.schema()
    };
  }

  static editForm = settingsForm;

  init() {}

  attachReact(element) {
    return ReactDOM.render(<MapComponentReact component={this.component} form={this} openNow={this.component.openNow}  />, element);
  }

  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
